export default "__VITE_ASSET__Bj39n2WY__"